import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { DOCUMENTS_PULSE_ICON_PATH } from '../../constants';
import type { TDocumentsPulseIconProps } from '../../types';

export const DocumentsPulseIcon = ({ size, color }: TDocumentsPulseIconProps) => (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <Path d={DOCUMENTS_PULSE_ICON_PATH} stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    </Svg>
);
